import React, { useState } from 'react'
import Users from './users'
import Icon from '../../components/Icon'
import { Button, Tooltip } from 'antd'

const USERS = 'Users'
const PERMISSIONS = 'Permissions'
const TABS = [USERS, PERMISSIONS]

const styleForCollectionIcon = { fontSize: 18, verticalAlign: 1, marginRight: 5 }

const style = {
  fontSize: 20,
  verticalAlign: '0.1em'
}

const styleButton = {
  boxShadow: 'none'
}
const Everyone = ({ permissions, users, collections, update, reload, isActiveSave, save }) => {
  const [tab, setTab] = useState(PERMISSIONS)

  const hasPermission = (name) => {
    return permissions.indexOf(name) === -1
  }
  const onChange = (key) => {
    if (permissions.indexOf(key) > -1) {
      permissions = permissions.filter(permissions => permissions !== key)
      update([...permissions])
    } else {
      update([...permissions, key])
    }
  }
  return (
    <div className="col-8">
      DETAILS
      <div className="my-2 border collectionItem knackly-plain p-4">
        <div className={'row'}>
          <div className="col-6">
            <h2>{'Everyone'}</h2>
          </div>
          <div className={'col-6'}>
            {isActiveSave && <div className={'float-right'}>
              <Tooltip placement="bottom" title={'Save'}>
                <Button shape="circle" style={styleButton}
                        className="m-1 border-0 bg-transparent"
                        onClick={async () => save()}>
                  <Icon type="icon-save" style={style}/>
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title={'Revert'}>
                <Button shape="circle" style={styleButton}
                        className="m-1 border-0 bg-transparent"
                        onClick={() => reload()}>
                  <Icon type="icon-undo" style={style}/>
                </Button>
              </Tooltip>
            </div>}
          </div>
          <div className="col-12">
            <ul className="nav nav-tabs text-uppercase" role="tablist">
              {TABS.map(TAB => (<li key={TAB} className="nav-item mr-2 cursorPointer" onClick={() => {
                setTab(TAB)
              }
              }>
                <div className={TAB === tab ? 'nav-link active' : 'nav-link'} role="tab"
                     aria-selected="true">{TAB}</div>
              </li>))}
            </ul>

            <div className={'w-100 p-2 knackly-back overflow-auto'} style={{maxHeight: '72vh'}}>
              {tab === USERS && <Users users={users} usersOfTenant={[]} update={update} disabled={true}/>}
              {tab === PERMISSIONS &&
              <div>
                <div className={'w-100'}>
                  <div className={'d-flex flex-row'}>
                    <div className={'py-2 pl-2 knacklyBlock d-flex'}>Catalog</div>
                    <div className={'py-2 knacklyBlock d-flex'} style={{ width: 75 }}>Full Access</div>
                  </div>
                  {collections.map(({ name }) => (
                    <div key={'permission-' + name} className={'d-flex flex-row'}>
                      <div className={'knackly-plain py-2 pl-2 blockPermissions'}>
                        <Icon type={'icon-cabinet1'} style={styleForCollectionIcon}/>
                        {name}
                      </div>
                      <div className={'knackly-plain py-2 blockPermissions'} style={{ width: 75 }}>
                        <div className="form-check text-center p-0 m-0">
                          <input className="form-check-input position-static p-0 m-0" type="checkbox"
                                 onChange={() => onChange(name)} checked={hasPermission(name)}/>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Everyone
